import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cash-flow-form"
// Toggles the inline cash flow form visibility
export default class extends Controller {
  static targets = ["form"]

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.formTarget.classList.toggle("hidden")
  }
}
